<template>
  <div>
    <!-- Product header -->
    <div class="opc-simple-header">
      <div class="opc-simple-header__header-left">
        <div class="opc-simple-header__icon" v-if="icon">
          <img :src="icon" :alt="title + ' Icon'" />
        </div>
        <div class="opc-simple-header__title-section">
          <h2 class="opc-simple-header__title">{{ title }}</h2>
          <div class="opc-simple-header__subtitle" v-if="$slots.subTitle">
            <slot name="subTitle"></slot>
          </div>
          <!-- Switch plan button -->
          <zm-button
            v-if="showRightButton"
            type="link"
            class="opc-simple-header__switch-plan-btn"
            data-testid="simple-edit-switch-plan-button"
            @click="handleRightButtonClick"
            :aria-label="`Switch ${title} plan`"
          >
            {{ rightButtonText || $t("billing.zone.explore_other_plans_edit") }}
          </zm-button>
        </div>
      </div>
    </div>

    <!-- Description text -->
    <div class="opc-simple-header__description">
      <slot name="description"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "SimpleHeader",
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: "",
    },
    showRightButton: {
      type: Boolean,
      default: false,
    },
    rightButtonText: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleRightButtonClick() {
      this.$emit("click-right-button");
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/scss-utils';
@import '@/styles/variables';
@import '@zoom/billing-responsive/styles/responsive.scss';

.opc-simple-header {
  margin-bottom: 16px;
  &__header-left {
    display: flex;
    gap: 12px;
    align-items: center;
  }

  &__switch-plan-btn {
    flex-shrink: 0;
    margin-right: 12px;
    align-self: flex-start;
  }

  &__icon {
    width: 40px;
    height: 40px;
    @include media(mobile) {
      width: 32px;
      height: 32px;
      flex-shrink: 0;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  &__title {
    font-weight: 600;
    font-size: 20px;
    letter-spacing: -0.45px;
  }

  &__title-section {
    display: flex;
    justify-content: space-between;
    width: 100%;
    @include media(mobile) {
      flex-direction: column;
      gap: 2px;
    }
  }

  &__subtitle {
    margin-top: 8px;
  }

  &__info-icon {
    width: 18px;
    height: 18px;
    color: var(--zoom-color-text-neutral, #686F79);
    cursor: pointer;
    flex-shrink: 0;
  }
}
</style>
